'use client';

import { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface NavigationContextType {
	displayTopbar: boolean;
	displayMainnav: boolean;
	setDisplayTopbar: (show: boolean) => void;
	setDisplayMainnav: (show: boolean) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: ReactNode }) {
	const [displayTopbar, setDisplayTopbar] = useState(true);
	const [displayMainnav, setDisplayMainnav] = useState(true);

	return (
		<NavigationContext.Provider
			value={{
				displayTopbar,
				displayMainnav,
				setDisplayTopbar,
				setDisplayMainnav,
			}}
		>
			{children}
		</NavigationContext.Provider>
	);
}

export function useNavigation() {
	const context = useContext(NavigationContext);
	if (context === undefined) {
		throw new Error('useNavigation must be used within a NavigationProvider');
	}

	return context;
}
